export const PRODUCTION_ENV = 'production';
export const isFloatingAssistantEnabledForEnv =
  import.meta.env.ENV !== PRODUCTION_ENV;

export const DRAWER_WIDTH_NORMAL_PX = 420;
export const DRAWER_WIDTH_MIN_PX = 360;
export const DRAWER_WIDTH_MAXIMIZED_VW = '70vw';
export const DRAWER_WIDTH_MAXIMIZED_CAP_PX = 1200;
export const PAGE_MIN_WIDTH_PX = 480;

export const DRAWER_WIDTH_NORMAL = `${DRAWER_WIDTH_NORMAL_PX}px`;
export const DRAWER_WIDTH_MAXIMIZED = `max(${DRAWER_WIDTH_NORMAL_PX}px, min(${DRAWER_WIDTH_MAXIMIZED_VW}, ${DRAWER_WIDTH_MAXIMIZED_CAP_PX}px, calc(100vw - ${PAGE_MIN_WIDTH_PX}px)))`;

export const DRAWER_CUSTOM_WIDTH_STORAGE_KEY =
  'floating-assistant-custom-width';

export const CENTER_MIN_WIDTH_PX = 500;
export const SIDEBAR_RESERVED_PX = 310;
export const DRAWER_EDGE_OFFSET_PX = 32;
export const DOCKED_LEFT_RESERVED_PX =
  CENTER_MIN_WIDTH_PX + SIDEBAR_RESERVED_PX + DRAWER_EDGE_OFFSET_PX;
export const FORCE_MAXIMIZE_MAX_VIEWPORT_PX =
  DOCKED_LEFT_RESERVED_PX + DRAWER_WIDTH_MIN_PX;

export function clampDockedWidth(rawPx: number, viewportWidth: number): number {
  return Math.max(
    DRAWER_WIDTH_MIN_PX,
    Math.min(rawPx, viewportWidth - DOCKED_LEFT_RESERVED_PX),
  );
}
